import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';

@Component({
  selector: 'app-add-state',
  templateUrl: './add-state.component.html',
  styleUrls: ['./add-state.component.css']
})
export class AddStateComponent implements OnInit {
  constructor(private dataService: DataService) { }

  response:string;
  status:boolean;

  provinceData: FormGroup = new FormGroup({
    province: new FormControl('', [Validators.required])
  })

  ngOnInit(): void {
  
  }

  submitProvinceData(data: any){
  	this.dataService.addState(data)
      .subscribe( (response:any) => {
        this.response = response.message;
        this.status = response.status;
      });
  }

}
